import { render, staticRenderFns } from "./profile-2.vue?vue&type=template&id=eaa76a0a&scoped=true&"
import script from "./profile-2.vue?vue&type=script&lang=js&"
export * from "./profile-2.vue?vue&type=script&lang=js&"
import style0 from "./style-2.scss?vue&type=style&index=0&id=eaa76a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa76a0a",
  null
  
)

export default component.exports